import { JsonFormBuilder } from './JsonFormBuilder';
import { JsonFormPresentation } from './JsonFormPresentation';
import type { BaseJsonForm } from './types';

export interface JsonFormProps extends BaseJsonForm {
  mode: 'builder' | 'presentation';
}

export const JsonForm = ({
  mode = 'presentation',
  ...props
}: JsonFormProps) => {
  return mode === 'builder' ? (
    <JsonFormBuilder {...props} />
  ) : (
    <JsonFormPresentation {...props} />
  );
};
